<template>
  <pagelayout :contentBgcolor="isDark && '#eeeeee'">
    <appbar :title="`指数${app_my_config.lotteryCredit.name}说明`" />
    <div class="guide">
      <div class="tit">两面</div>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">冠军</td>
            <td>
              买入规则:大盘指数小数点后两位数为基准值，第一位为冠军号
              <br />
              当冠军号大于4（不包含4）为“涨”，小于4（包含4）为“跌”；奇数为“单”，偶数为“双”。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">亚军</td>
            <td>
              买入规则:大盘指数小数点后两位数为基准值，第二位为亚军号
              <br />
              当亚军号大于4（不包含4）为“涨”，小于4（包含4）为“跌”；奇数为“单”，偶数为“双”。
            </td>
          </tr>
        </tbody>
      </table>
      <table width="100%" cellspacing="0" cellpadding="0">
        <tbody>
          <tr>
            <td rowspan="2" class="tit">牛熊</td>
            <td>
              买入规则:大盘指数小数点后两位数为基准值，第一位为冠军号，第二位为亚军号
              <br />
              牛熊规则大PK，当冠军大于亚军为“牛”，小于为“熊”，当冠军亚军出现一样的数字时为“和”则退还本金。
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </pagelayout>
</template>

<script>
import appConfigMixins from '@c/mixins/appConfig.mixins'
export default {
  mixins: [appConfigMixins]
}
</script>

<style lang="scss">
@import '~/assets/common/page/guide.scss';
</style>
